import { Component, OnInit } from '@angular/core';

import { IntelligenceDealershipStatsModel } from '../typings/intelligence.dealership-stats';
import { IntelligenceFormatService }        from '../intelligence.format.service';
import { IntelligenceService }              from '../intelligence.service';

const DEFAULT_STATS : IntelligenceDealershipStatsModel = {
  average_percentage_profit_last_12: '0%',
  average_units_sold_last_12       : 0,
  longest_held_stock               : '0 days',
  total_profit_last_month          : 0,
  total_profit_this_month          : 0,
  units_acquired_this_month        : 0,
  units_in_stock                   : 0,
  units_sold_last_month            : 0,
  units_sold_this_month            : 0
};

@Component({
  selector   : 'wor-intelligence-dealership-tab',
  template: require('./intelligence.dealership-tab.component.html')
})
export class DealershipTabComponent implements OnInit {
  public error   : boolean = false;
  public loading : boolean = true;

  public stats : IntelligenceDealershipStatsModel = { ...DEFAULT_STATS };

  private loadGeneration : number = 0;

  constructor (
    private intelligenceFormatService: IntelligenceFormatService,
    public intelligenceService       : IntelligenceService
  ) {}

  ngOnInit () : void {
    this.load();
  }

  load () : void {
    const generation = ++this.loadGeneration;

    this.error = false;
    this.loading = true;

    this.intelligenceService.getDealershipStats()
    .then(( stats : IntelligenceDealershipStatsModel ) => {
      if ( generation !== this.loadGeneration ) {
        return;
      }

      this.stats = { ...DEFAULT_STATS, ...( stats || {} ) };
    })
    .catch(() => {
      if ( generation === this.loadGeneration ) {
        this.error = true;
      }
    })
    .finally(() => {
      if ( generation === this.loadGeneration ) {
        this.loading = false;
      }
    });
  }

  profit ( value : number | string ) : string {
    return this.intelligenceFormatService.money(parseFloat(`${ value }`) || 0);
  }
}
